import React, { useEffect, useState } from "react";
import { Container, Grid, Typography, Button, Box, Card, Checkbox, Modal, IconButton, CircularProgress } from "@mui/material";
import CustomTextField from "../common/CustomTextField";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { CREATE_WISH } from "../../services/apiRoutes";
import { genericPost } from "../../services/authServices";
import MessageBox from "../../components/common/CustomMessageBox";
import CustomButton from "../common/CustomButton";
import FormImage from "../../assets/images/formImage.png";
import CloseIcon from "@mui/icons-material/Close";
import Logo from "../../assets/images/SPIRNEXS Logo Silver.png";
import CustomAutocomplete from "../common/CustomAutoComplete";
import { getCountries } from "../../services/CommonServices";




const WishForm = () => {
    const [openModal, setOpenModal] = useState(false);
    const handleClose = () => setOpenModal(false);
    const [conutries, setConutries] = useState([]);
    const [loading, setLoading] = useState(false);


    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    })
    const validationSchema = Yup.object({
        firstName: Yup.string().required("First Name is required"),
        lastName: Yup.string().required("Last Name is required"),
        email: Yup.string()
            .email("Invalid email format")
            .required("Email is required"),

        mobile: Yup.string().required("Mobile Number is required"),
        companyName: Yup.string().required("Company Name is required"),
        country: Yup.string().required("Country is required"),
        disclaimer: Yup.boolean().oneOf([true], "You must agree to the disclaimer"),


    });
    const initialValues = {
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        companyName: "",
        country: "",
        disclaimer: false,

    };

    const handleSubmit = async (values, { resetForm }) => {
        setLoading(true); // 👈 start loader

        try {
            const response = await genericPost(CREATE_WISH, values, {});

            if (response.status === 201) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "Added successfully",
                    type: "success",
                });
                resetForm();
                setOpenModal(true);

            } else if (response.status === 409) {
                setMessage({
                    open: true,
                    text: response?.message || 'Email/Mobile already exists',
                    type: 'error',
                });
            } else {
                setMessage({
                    open: true,
                    text: response?.message || 'An unexpected error occurred',
                    type: 'error',
                });
            }
        } catch (error) {
            setMessage({
                open: true,
                text: 'Something went wrong. Please try again.',
                type: 'error',
            });
        }
        finally {
            setLoading(false);
        }
    };

    const customStyle = {
        text: {
            // fontFamily: "Helvetica, sans-serif",
            fontFamily: "Helvetica",
            color: "#FFFFFF",
            textTransform: "capitalize"

        },
        compressed: { fontWeight: 600, fontStyle: "normal" },
        bold: { fontWeight: 100, fontStyle: "normal" },
        boldItalic: { fontWeight: 700, fontStyle: "italic" },
        light: { fontWeight: 300, fontStyle: "normal" },
        oblique: { fontWeight: 400, fontStyle: "italic" },
        roundedBold: { fontWeight: 700, fontStyle: "normal" },
        regular: { fontWeight: 400, fontStyle: "normal" },
    };
    const getCommonData = async () => {
        const getConutriesData = await getCountries()
        setConutries(getConutriesData)
    }


    useEffect(() => {
        getCommonData()
    }, [])


    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
                    <Form>
                        <Container maxWidth="lg"
                            sx={{
                                mt: { xs: 0, sm: 0, md: 6 },
                                mb: { xs: 0, sm: 0, md: 6 },
                                p: { xs: 2, sm: 2, md: 2, lg: 0, xl: 0 },


                            }}>
                            <Card
                                variant="outlined"
                                sx={{
                                    p: 4,
                                    borderRadius: 3,
                                    boxShadow: 4,
                                    background: "linear-gradient(65deg, #5E00DD, #007BFF , #5C03DE )",
                                    border: "none",
                                    ...customStyle.text,
                                }}
                            >
                                <Grid container spacing={4}  >
                                    <Grid item xs={12} md={6}
                                    >
                                        <Typography sx={{
                                            marginLeft: { xs: 1, sm: 1, md: "60px" },
                                        }}
                                        >
                                            <Typography
                                                variant="h1"
                                                gutterBottom

                                                sx={{
                                                    color: "white",
                                                    textAlign: "left",
                                                    display: "block",
                                                    textTransform: "capitalize",
                                                    mb: { xs: 0, sm: 0, md: 3 },
                                                    mt: { xs: 0, sm: 0, md: 2 },
                                                    fontSize: {
                                                        xs: "28px",
                                                        sm: "36px",
                                                        md: "52px",
                                                        lg: "52px",
                                                        xl: "60px",
                                                    },
                                                    lineHeight: {
                                                        xs: "32px",
                                                        sm: "40px",
                                                        md: "60px",
                                                        lg: "60px",
                                                        xl: "70px",
                                                    },
                                                }}

                                            >
                                                <br />
                                                <span style={{ ...customStyle.text, ...customStyle.light }}> Simplify your</span>
                                                <br />
                                                <span style={{ ...customStyle.text, ...customStyle.bold }}> import-export </span>
                                                <br />
                                                <span style={{ ...customStyle.text, ...customStyle.light }}> business</span>
                                            </Typography>


                                            <Box sx={{
                                                fontSize: {
                                                    xs: "10px",
                                                    sm: "10px",
                                                    md: "10px",
                                                    lg: "18px",
                                                    xl: "18px",
                                                },
                                            }}>
                                                <div
                                                    style={{
                                                        ...customStyle.regular,
                                                        fontFamily: "Lato",
                                                        display: "flex",
                                                        justifyContent: "flex-start",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        opacity: 1,
                                                    }}
                                                >

                                                    Add your wishlist
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            fontSize: {
                                                                xs: "20px",
                                                                sm: "25px",
                                                                md: "32px",
                                                                lg: "40px",
                                                                xl: "45px",
                                                            },
                                                            color: "white",
                                                            textTransform: "lowercase",
                                                            fontWeight: "100"
                                                        }}
                                                    >
                                                        <div style={{ fontFamily: "White Dream, sans-serif", }}>Free </div>
                                                    </Box>
                                                </div>
                                            </Box>
                                            {/* <br /> */}
                                            <Box sx={{
                                                fontSize: {
                                                    xs: "12px",
                                                    sm: "12px",
                                                    md: "16px",
                                                    lg: "16px",
                                                    xl: "18px",
                                                },

                                            }}
                                            >
                                                <p style={{
                                                    color: "white",
                                                    fontFamily: "Lato",
                                                    textAlign: "left",
                                                    display: "block",
                                                    mb: 3,
                                                    mt: 2,
                                                    textTransform: "capitalize",
                                                    fontWeight: "100"
                                                }}>
                                                    Our system is built to help you save time, reduce <br /> errors, and gain <strong> full
                                                        visibility into your global<br /> trade operations.</strong>
                                                </p>
                                            </Box>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={6} >
                                        <Box

                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 2,
                                                pt: { xs: 1, sm: 1, md: 4 },
                                                pb: { xs: 1, sm: 1, md: 4 },
                                                pr: { xs: 1, sm: 1, md: 8 },
                                                pl: { xs: 1, sm: 1, md: 8 },
                                                mt: { xs: 1, sm: 1, md: 2 },
                                                mb: { xs: 1, sm: 1, md: 2 },
                                                ml: { xs: 1, sm: 1, md: 2 },
                                                mr: { xs: 1, sm: 1, md: 4 },
                                                borderRadius: 2,
                                                background: "linear-gradient(45deg, #afeaf8,   #9c54c0)",
                                                boxShadow: 2,
                                                borderRadius: "20px",

                                            }}

                                        >
                                            <CustomTextField
                                                placeholder="First Name"
                                                sx={{ backgroundColor: "white", }}
                                                name="firstName"
                                                value={values.firstName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.firstName && Boolean(errors.firstName)}
                                                helperText={touched.firstName && errors.firstName}
                                            />
                                            <CustomTextField
                                                placeholder="Last Name"
                                                sx={{ backgroundColor: "white", }}
                                                name="lastName"
                                                value={values.lastName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.lastName && Boolean(errors.lastName)}
                                                helperText={touched.lastName && errors.lastName}
                                            />
                                            <CustomTextField
                                                placeholder="Company Name"
                                                sx={{ backgroundColor: "white", }}
                                                name="companyName"
                                                value={values.companyName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.companyName && Boolean(errors.companyName)}
                                                helperText={touched.companyName && errors.companyName}
                                            />


                                            <CustomAutocomplete
                                                options={conutries}
                                                getOptionLabel={(option) => option.title}
                                                value={conutries.find((option) => option.id === values.country) || null}
                                                onChange={(e, newValue) => {
                                                    setFieldValue('country', newValue ? newValue.id : '');
                                                }}
                                                placeholder="Select Country"
                                                error={touched.country && !!errors.country}
                                                helperText={touched.country && errors.country}
                                                sx={{ backgroundColor: "white", }}

                                            />

                                            <CustomTextField
                                                placeholder="Email"
                                                type="email"
                                                sx={{ backgroundColor: "white", }}
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.email && Boolean(errors.email)}
                                                helperText={touched.email && errors.email}
                                            />
                                            <CustomTextField
                                                placeholder="Mobile no."
                                                type="number"
                                                sx={{ backgroundColor: "white", }}
                                                name="mobile"
                                                value={values.mobile}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.mobile && Boolean(errors.mobile)}
                                                helperText={touched.mobile && errors.mobile}
                                            />
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column", // so error can appear below
                                                    alignItems: "flex-start",
                                                }}
                                            >


                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "flex-start",
                                                    }}
                                                >
                                                    <Checkbox
                                                        size="small"
                                                        sx={{ p: 0.5 }}
                                                        name="disclaimer"
                                                        checked={values.disclaimer}
                                                        onChange={handleChange}
                                                    />

                                                    <Typography
                                                        sx={{
                                                            textAlign: "left",
                                                            textTransform: "capitalize",
                                                            fontSize: "9px",
                                                            lineHeight: 1.3,
                                                            ml: 0.5,
                                                            color: "#000000"
                                                        }}
                                                    >
                                                        By clicking the Call Me Back button below, I explicitly agree to receive a
                                                        call from Spinesx or its partners on my mobile in order to assist me.
                                                    </Typography>
                                                </Box>
                                                {touched.disclaimer && errors.disclaimer && (
                                                    <Typography sx={{ color: "red", fontSize: "10px", mt: 0.5 }}>
                                                        {errors.disclaimer}
                                                    </Typography>
                                                )}

                                            </Box>

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                            >

                                                <Button
                                                    type="submit"
                                                    sx={{
                                                        width: "100px",
                                                        border: "none",
                                                        background: "transparent linear-gradient(266deg, #5E00DD 0%, #1276E9 100%) 0% 0% no-repeat padding-box",
                                                        textTransform: "capitalize",
                                                        color: "white",
                                                        fontWeight: "300",
                                                        borderRadius: "8px",
                                                        boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                                                        "&:hover": {
                                                            background: "transparent linear-gradient(266deg, #5E00DD 0%, #1276E9 100%) 0% 0% no-repeat padding-box",

                                                        },
                                                    }}
                                                >
                                                    {loading ? (
                                                        <CircularProgress size={20} color="inherit" />
                                                    ) : (
                                                        "Submit"
                                                    )}

                                                </Button>
                                            </Box>

                                        </Box>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Container>
                    </Form>
                )}
            </Formik>

            <Modal
                open={openModal}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "87%",
                        height: "100vh",
                        maxHeight: "calc(100vh - 20px)",
                        p: 4,
                        borderRadius: 2,
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        background:
                            "transparent linear-gradient(54deg, #5C03DE 0%, #007BFF 62%, #5E00DD 100%) 0% 0% no-repeat padding-box",
                        boxShadow: "5px 3px 25px #00000040",
                        borderRadius: "20px",
                        opacity: 1,
                    }}
                >
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            color: "white",
                            fontSize: "20px",
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Box>
                        <Typography
                            sx={{
                                textAlign: "center",
                                fontSize: {
                                    xs: "28px",
                                    sm: "35px",
                                    md: "45px",
                                    lg: "55px",
                                    xl: "60px",
                                },
                                lineHeight: "120px",
                                fontWeight: "normal",
                                color: "#FFFFFF",
                                opacity: 1,
                            }}
                        >
                            <div style={{ fontFamily: "White Dream, sans-serif", }}>Thank You </div>
                        </Typography>

                        <Typography
                            sx={{
                                textAlign: "center",
                                fontSize: {
                                    xs: "20px",
                                    sm: "25px",
                                    md: "30px",
                                    lg: "30px",
                                    xl: "30px",
                                },
                                lineHeight: "49px",
                                fontWeight: 300,
                                color: "#FFFFFF",
                                opacity: 1,
                            }}
                        >
                            <div style={{
                                ...customStyle.regular,
                                fontFamily: "Lato",

                            }}>
                                For Choosing
                            </div>
                        </Typography>

                        <Box
                            component="img"
                            src={Logo}
                            alt="Logo"
                            sx={{
                                width: {
                                    xs: "200px",
                                    sm: "200px",
                                    md: "500px",
                                    lg: "700px",
                                    xl: "700px",
                                },
                                height: "auto",
                                marginTop: "30px",
                            }}
                        />
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default WishForm;



